import styles from './RenderForm.module.css'
import { useState, useEffect } from 'react'
import RenderField from '../RenderField/RenderField'
import { useContext } from 'react'
import ButtonSendForm from '../ButtonSendForm/ButtonSendForm'
import { ViewFormContext } from '../../pages/ViewForm/components/store/store.ViewForm'
import dayjs from 'dayjs'
import { Alert, Result, Button } from 'antd'
import { observer } from 'mobx-react-lite'
import { FormProvider, useForm } from 'react-hook-form'
import { handleFormResponse } from '../../services/api'
import { message, notification } from 'antd'
import headersForms from '../HeadersForms/headersForms'
import LoadingPage from '../Loading/LoadingPage'

import SuccessSubmit from './components/SuccessSubmit/SuccessSubmit'

notification.config({
  placement: 'top',
  duration: 3,
  top: 50,
})

const RenderForm = observer(
  ({
    DataForm,
    DataFields,
    isActiveSubmit,
    urlCode,
    isFakeSubmit,
    isUpdateSubmit,
    editingFieldId,
    isModalAddNewResponse,
    isDuplicateConflict,
  }) => {
    const viewFormContext = useContext(ViewFormContext)
    const [formSubmitted, setFormSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(true)
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false)

    const headerComponent = DataForm.show_header
      ? headersForms.find(
          (header) => header.value === DataForm.header_type.typeHeader
        )?.component
      : null

    const methods = useForm()
    const { control, setValue } = methods
    const { formState } = methods
    const { errors } = formState
    const viewFormStyle = { ...DataForm.design }
    const buttonSendStyle = { ...DataForm.design_button }

    // Utilisez une cartographie pour les conversions de date
    const formatDateBasedOnType = {
      Date: (value) => dayjs(value).format('DD-MM-YYYY'),
      timepicker: (value) => dayjs(value).format('HH:mm:ss'),
      'Range Date': (value) =>
        value.map((date) => dayjs(date).format('DD-MM-YYYY')),
      Upload: (value) => console.log('upload'),
    }

    const transformDataForDB = (data) => {
      console.log('Je rentre dans transformDataForDB')
      return Object.entries(data).map(([fieldId, value]) => {
        const fieldDefinition = DataFields.find(
          (field) => field.idFieldCanvas === fieldId
        )

        if (
          fieldDefinition.type !== 'Upload' &&
          formatDateBasedOnType[fieldDefinition.type]
        ) {
          value = value
            ? formatDateBasedOnType[fieldDefinition.type](value)
            : null
        }

        console.log('fieldID et value AVANT ', fieldId, value)

        if (value === null || value === undefined || value === '') {
          value = ''
        }

        console.log('fieldID et value APRES ', fieldId, value)

        return {
          fieldType: fieldDefinition.type,
          value,
          fieldId,
        }
      })
    }

    const sendFormDataToAPI = async (
      formData,
      isUpdateSubmit,
      isModalAddNewResponse,
      isDuplicateConflict
    ) => {
      try {
        setIsLoading(true)
        setIsSubmitSuccess(false)
        const response = await handleFormResponse(formData)
        console.log('formData:', formData)
        console.log('Response:', response)
        console.log('isModalAddNewResponse', isModalAddNewResponse)
        console.log('isDuplicateConflict', isDuplicateConflict)

        if (response.status === 'success') {
          setIsSubmitSuccess(true)
          console.log('Cette réponse est un SUCCES')

          if (isUpdateSubmit) {
            viewFormContext.toggleModalVisibilityUpdateOpen(false)

            notification.success({
              message: 'Modifications appliquées avec succès',
            })
          } else if (isDuplicateConflict) {
            viewFormContext.toggleModalDuplicateResponseOpen(false)
            notification.success({ message: 'Réponse dupliquée avec succès' })
          } else if (isModalAddNewResponse) {
            viewFormContext.toggleModalAddNewResponseOpen(false)

            notification.success({ message: 'Réponse ajoutée avec succès' })
          } else {
            setFormSubmitted(true)
          }
        }
      } catch (error) {
        console.error(
          "Erreur lors de l'envoi de la réponse du formulaire:",
          error
        )
      } finally {
        setIsLoading(false)
        setIsModalVisible(false)
      }
    }

    const onSubmit = async (data) => {
      console.log('Data received from useForm:', data)

      // Parcourir les champs à la recherche d'un champ 'Upload'
      const uploadFields = DataFields.filter(
        (field) => field.field_type === 'Upload'
      )

      uploadFields.forEach((uploadField) => {
        const fileField = methods.getValues(uploadField.idFieldCanvas)
        if (fileField && fileField[0]) {
          console.log('Found file:', fileField[0])
          data[uploadField.idFieldCanvas] = fileField[0]
        }
      })

      if (isActiveSubmit) {
        console.log('onSubmit has been called')

        const transformedData = transformDataForDB(data)

        if (!isFakeSubmit) {
          let formData = {
            form__url_code: viewFormContext.url_code,
            fields_values: transformedData,
          }

          if (isUpdateSubmit) {
            formData.isEditing = isUpdateSubmit
            formData.fieldId = editingFieldId
          }

          sendFormDataToAPI(
            formData,
            isUpdateSubmit,
            isModalAddNewResponse,
            isDuplicateConflict
          )
          console.log(transformedData)
          return
        }
      }
      console.log('Form is read only, submission is blocked')
    }

    if (isLoading) {
      return <LoadingPage loadingMessage={true} />
    }

    if (isSubmitSuccess) {
      return (
        <SuccessSubmit DataForm={DataForm} urlCode={viewFormContext.url_code} />
      )
    }

    return (
      <FormProvider {...methods}>
        <form
          className={styles.form_container}
          onSubmit={methods.handleSubmit((data) => {
            console.log('handleSubmit has been called')
            onSubmit(data)
          })}
        >
          <> {headerComponent}</>
          <div className={styles.page} style={viewFormStyle}>
            <div className="canvas-fields">
              <div className={styles.container__errors}>
                {Object.keys(errors).length > 0 && (
                  <div className={styles.errorContainer}>
                    {Object.entries(errors)
                      .slice(0, 1)
                      .map(([key, value]) => (
                        <Alert
                          key={key}
                          message={`Veuillez noter que tous les champs encadrés en rouge indiquent une erreur.`}
                          type="error"
                          showIcon
                        />
                      ))}
                  </div>
                )}
              </div>

              {DataFields &&
                DataFields.map((field) => (
                  <RenderField
                    key={field.id}
                    setValue={setValue}
                    field={{ ...field, type: field.field_type }}
                    errors={methods.formState.errors}
                    isActiveSubmit={isActiveSubmit}
                    control={control}
                    isDuplicateConflict={isDuplicateConflict}
                  />
                ))}

              {DataForm.show_send_btn && (
                <div className={`${styles.container__btn}`}>
                  <ButtonSendForm
                    style={buttonSendStyle}
                    text={'Envoyer'}
                    onSubmit={methods.handleSubmit(onSubmit)}
                  />
                </div>
              )}
            </div>
          </div>
        </form>
      </FormProvider>
    )
  }
)

export default RenderForm
